import ScrollToHelper from '../../00_utilities/helpers/ScrollToHelper';

class Button {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        if (this.elem.classList.contains('button--scroll-to')) {
            this.addSmoothScroll(element);
        }

        const processingButtons = document.querySelectorAll(".button--processing");
        if (processingButtons) {
            processingButtons.forEach(processingButton => {
                const eventHandler = 'wpcf7submit';
                this.showProcessingButton(processingButton, eventHandler);
            });
        }
    }

    showProcessingButton(processingButton, eventHandler) {
        processingButton.addEventListener("click", function() {
            processingButton.style.setProperty("--show-processing", "block");
        });

        document.addEventListener( eventHandler, function( event ) {
            processingButton.style.removeProperty('--show-processing');
        });
    }

    addSmoothScroll(element) {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            ScrollToHelper.scrollTo(element, 0);
        });
    }
}

export default Button;
